export default "__VITE_ASSET___Zkrqd4o__"